/* global axios */
import ApiClient from '../ApiClient';

class CopilotDocumentsAPI extends ApiClient {
  constructor() {
    super('copilot/documents', { accountScoped: true });
  }

  get({ page = 1, search, status } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        search,
        status,
      },
    });
  }
}

export default new CopilotDocumentsAPI();
